import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';


import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.svg';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import flask from '../assets/flask.png';
import tensorflow from '../assets/tensorflow.png';
import mysql from '../assets/mysql.png';
import mongodb from '../assets/mongodb.png';
import linux from '../assets/linux.png';
import azure from '../assets/azure.png';
import tailwindcss from '../assets/tailwindcss.png';
import vscode from '../assets/vscode.png';




import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.jpeg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';



import kvrlogoblack from '../assets/kvrlogoblack.png';
import kvrlogowhite from '../assets/kvrlogowhite.png';

// eslint-disable-next-line
export default {
  flask,
  tensorflow,
  vscode,
  azure,
  tailwindcss,
  linux,
  api,
  cpp,
  css,
  git,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  kvrlogoblack,
  kvrlogowhite,
  mongodb,
  mysql,
  email,
  mobile,
};